import { useContext } from "react";
import Context from "../../../../context";
import {
  CustomBadges,
  CustomIcon,
  TableNullData,
  UserInformation,
} from "../../../../components";
import { ICreateAndUpdateDriver } from "../../../../types/driver.interface";
import { ICreateAndUpdateOrder } from "../../../../types/order.interface";
import { ORDER_STATUS } from "../../../../values/dropdownItems";

const Body = (data: any) => {
  const { resultOrder, setSelectedOrder, setShowModal } = useContext(
    Context.OrderScreen
  );

  const orders = resultOrder?.data?.result?.docs;

  const onDetail = (order: ICreateAndUpdateOrder) => {
    setSelectedOrder!(order);
    setShowModal!("DETAIL");
  };
  const onChangeStatus = (order: ICreateAndUpdateOrder) => {
    setSelectedOrder!(order);
    setShowModal!("CHANGE_STATUS");
  };

  if (orders?.length <= 0 || !data) return <TableNullData />;
  return (
    <tbody id="driver-table-body-container">
      {orders?.map((order: any, index: number) => {
        return (
          <tr key={`driver-${index}`}>
            <td className="pointer">
              <UserInformation
                avatar={order?.client?.avatar}
                name={order?.client?.firstName}
                lastName={order?.client?.lastName}
                phoneNumber={order?.client?.phoneNumber}
              />
            </td>
            <td className="pointer">
              <CustomBadges title={order?.cities?.name} type="primary" />
            </td>
            <td>{order?.description}</td>
            {/* Status */}
            <td className="pointer">{order?.address?.completeAddress}</td>
            <td className="pointer">
              {" "}
              <CustomBadges
                title={
                  ORDER_STATUS?.find((item) => item.value === order?.status)
                    ?.name as string
                }
                type="warning"
              />
            </td>

            {/* actions */}
            <td>
              <div className="table-actions-buttons">
                {/* Edit Icon */}
                <CustomIcon
                  icon="fas fa-list"
                  hoverTitle="جزئیات"
                  onClick={() => onDetail(order)}
                />
                <CustomIcon
                  icon="fa-solid fa-battery-half"
                  hoverTitle="تغییر وضعیت"
                  onClick={() => onChangeStatus(order)}
                />
              </div>
            </td>
          </tr>
        );
      })}
    </tbody>
  );
};

export default Body;
